
export default () => ({
  card: {
    margin: 0,
    height: '100%',
  },
  cardHeader: {
    alignItems: 'center',
    padding: 16,
  },
  cardContent: { padding: '0 1em 1em 1em' },
  avatar: { marginRight: '.5em' },
});
